// ONDE A CANDIDATURA ACONTECE — um lugar só decide, para toda tela (vaga, mural, oportunidades).
//
// `soNoSiteDaEmpresa` vem do servidor apenas para a vaga MARCADA assim. A vaga ESPELHADA de portal
// (Greenhouse, Workday, Oracle, SmartRecruiters...) chega como Fonte=Externa com o link da vaga e caía num
// atalho: um <a> solto, sem registrar a ida e sem o "Conseguiu?" na volta — enquanto a ficha e os cards diziam
// "candidatura pelo eaiRH". O Carlos (13/09/2026) e o Bruno (14/09/2026) montaram currículo completo, abriram
// várias dessas vagas e "saíram sem se candidatar": podem ter ido, e o eaiRH não tinha como saber.
//
// E-mail e WhatsApp continuam fora: são canais de contato divulgados pela empresa, não o site dela.
export function noSiteDaEmpresa(v) {
  if (!v) return false;
  if (v.soNoSiteDaEmpresa) return true;
  if (v.fonte !== "Externa") return false;
  const u = (v.urlExterna || "").trim();
  if (!u) return false;
  if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(u)) return false; // e-mail
  if (/^[\d\s()+-]+$/.test(u)) return false;              // telefone
  if (/wa\.me|whatsapp/i.test(u)) return false;           // WhatsApp
  return true;
}
